<div class="banners-overlay" [class.overlay-mode]="overlayMode">
  <div class="banner banner-{{ann.type}}" *ngFor="let ann of systemAlerts">
    <div class="banner-header"
         [class.expandable]="hasBody(ann)"
         (click)="hasBody(ann) && toggleExpand(ann.id)"
         (contextmenu)="dismiss(ann.id); $event.preventDefault()">
      <mat-icon class="type-icon">{{typeIcon(ann.type)}}</mat-icon>
      <span class="banner-title">{{ann.title}}</span>
      <button mat-icon-button class="action-btn" *ngIf="hasBody(ann)"
        (click)="toggleExpand(ann.id); $event.stopPropagation()"
        [title]="(isExpanded(ann.id) ? 'systemAlerts.collapse' : 'systemAlerts.expand') | translate">
        <mat-icon [svgIcon]="isExpanded(ann.id) ? 'expand_less' : 'expand_more'"></mat-icon>
      </button>
      <button mat-icon-button class="action-btn close-btn"
        (click)="dismiss(ann.id); $event.stopPropagation()"
        (contextmenu)="dismissAll($event)"
        [title]="'systemAlerts.dismiss' | translate">
        <mat-icon>close</mat-icon>
      </button>
    </div>
    <div class="banner-body" *ngIf="hasBody(ann) && isExpanded(ann.id)">{{ann.body}}</div>
  </div>
</div>
